import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';

import { isElAboveViewportBottom, isElBelowViewportTop } from '@rover/utilities/ui';

export default Backbone.View.extend({
  initialize(options) {
    this.$container = this.$el.parent();
    $(window).on('safeScroll', _.bind(this.toggle, this));
  },
  toggle() {
    if (isElBelowViewportTop(this.$container)) {
      this.unfix();
    } else if (isElAboveViewportBottom($('.js-search-results-view'))) {
      this.unfix();
    } else {
      this.fix();
    }
  },
  fix() {
    this.$el.addClass('fixed-bottom');
  },
  unfix() {
    this.$el.removeClass('fixed-bottom');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/fixed_search_filters_button_view.js